export default {
  // Промежуток времени между отправкой кода восстановления
  recoveryCodeSendingDelay: 120
};
